import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import { workforceActions } from "redux/Ldb/actions";
import ModalContainer from "components/common/ModalContainer";
import Button from "components/common/Button";
import { useMergedSearchParams } from "helpers/mergeSearchParams";

const Tabs = ({
    setActiveTab,
    activeTab,
}: {
    setActiveTab: (tab: number) => void;
    activeTab: number;
}) => {
    const tabs = ["AI workflow setup", "Tasks manager", "General settings"];
    const dispatch = useAppDispatch();
    const { agentId } = useParams();
    const { updateSearchParams } = useMergedSearchParams();
    const [searchParams] = useSearchParams();
    const currTab = searchParams.get("currTab");

    useEffect(() => {
        if (currTab) {
            setActiveTab(Number(currTab));
        }
    }, [currTab]);

    const [agentIsActive, setAgentIsActive] = useState(false);
    const [lockModal, setLockModal] = useState(false);

    const { fetchSingleAgentSuccess, fetchingSingleAgent } = useAppSelector(
        (state) => state?.workforce
    );
    useEffect(() => {
        if (agentId) {
            dispatch(workforceActions.getSingleAgent(agentId));
            setAgentIsActive(true);
        }
    }, [agentId, dispatch]);

    useEffect(() => {
        if (fetchSingleAgentSuccess) {
            if (
                typeof fetchSingleAgentSuccess?.activeAgent === "object" &&
                fetchSingleAgentSuccess?.activeAgent?._id
            ) {
                setAgentIsActive(true);
            } else {
                setAgentIsActive(false);
            }
        }
    }, [fetchSingleAgentSuccess]);
    return (
        <>
            <div className="flex justify-center border-b border-slate-100 gap-6 mt-3">
                {tabs?.map((value, idx) => (
                    <div
                        key={`${value + idx}`}
                        onClick={() => {
                            if (idx === 1 && !agentIsActive) {
                                setLockModal(true);
                            } else {
                                updateSearchParams({
                                    currTab: idx.toString(),
                                });
                            }
                        }}
                        className={` flex items-center text-sm  font-rocGroteskMedium pt-[6.5px] pb-2 cursor-pointer ${
                            activeTab === idx
                                ? "text-slate-700 border-y-10 border-b-[2px]"
                                : "text-slate-500"
                        }`}
                    >
                        {value}
                    </div>
                ))}
            </div>

            <ModalContainer
                open={lockModal}
                modalClassName={"py-10 px-10"}
                tailwindClassName="w-[552px]"
                showCloseIcon={false}
                closeModal={() => {
                    setLockModal(false);
                }}
            >
                <div className="bg-white rounded-[8px] relative">
                    <div className="">
                        <div className="px-6 py-4">
                            <i className="ri-lock-fill text-[24px] text-gm-50"></i>
                        </div>
                        <div className="px-6 font-rocGroteskMedium">
                            <span className="block mb-2 text-[18px] text-[#142837]">
                                Tasks Locked Until Agent Activation
                            </span>
                            {/* Changes saved successfully! */}
                            <p className="mt-1 text-base text-slate-500 ">
                                You can't access Tasks until this AI Agent has been created and
                                activated. Once setup is complete, you'll be able to view and
                                automate tasks linked to this workflow.{" "}
                            </p>
                        </div>
                    </div>
                    <div className="py-4 px-6 flex justify-end space-x-4">
                        <Button
                            btnText={"Back to Setup"}
                            btnClassname=" !w-fit !py-3 cursor-pointer !text-[14px] !text-g-75 !border border-n-20 !font-rocGroteskMedium !px-4"
                            onClick={() => {
                                setLockModal(false);
                                updateSearchParams({
                                    currTab: "0",
                                });
                            }}
                        />
                    </div>
                </div>
            </ModalContainer>
        </>
    );
};

export default Tabs;
